import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SortControls = ({
  sortBy,
  sortOrder,
  onSortChange,
  viewMode,
  onViewModeChange,
  resultsCount,
  onToggleFilters
}) => {
  const sortOptions = [
    { value: 'relevance', label: 'Relevance' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'popularity', label: 'Most Popular' },
    { value: 'rating', label: 'Highest Rated' },
    { value: 'newest', label: 'Newest First' }
  ];

  const handleSortChange = (value) => {
    if (value?.includes('price-')) {
      onSortChange('price', value === 'price-low' ? 'asc' : 'desc');
    } else {
      onSortChange(value, 'desc');
    }
  };

  const getCurrentSortValue = () => {
    if (sortBy === 'price') {
      return sortOrder === 'asc' ? 'price-low' : 'price-high';
    }
    return sortBy;
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
      <div className="flex items-center space-x-4">
        {/* Mobile Filter Toggle */}
        <Button
          variant="outline"
          onClick={onToggleFilters}
          className="lg:hidden"
        >
          <Icon name="Filter" size={16} className="mr-2" />
          Filters
        </Button>

        {/* Results Count */}
        <p className="text-sm text-muted-foreground">
          {resultsCount} {resultsCount === 1 ? 'service' : 'services'} found
        </p>
      </div>

      <div className="flex items-center space-x-4">
        {/* Sort Controls */}
        <div className="flex items-center space-x-2">
          <span className="text-sm text-muted-foreground hidden sm:block">Sort by:</span>
          <Select
            options={sortOptions}
            value={getCurrentSortValue()}
            onChange={handleSortChange}
            className="min-w-[160px]"
          />
        </div>

        {/* View Mode Toggle */}
        <div className="flex items-center border border-border rounded-lg p-1">
          <Button
            variant={viewMode === 'grid' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('grid')}
            className="px-3"
          >
            <Icon name="Grid3X3" size={16} />
          </Button>
          <Button
            variant={viewMode === 'list' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('list')}
            className="px-3"
          >
            <Icon name="List" size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SortControls;